var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-overlay',{attrs:{"show":_vm.show,"z-index":1000},on:{"click":function($event){_vm.show = false}}},[_c('div',{staticClass:"wrapper"},[(_vm.hasErrorImg)?_c('img',{attrs:{"src":_vm.vuexInitData.game_extra_config.emergency_qr,"alt":""}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }